import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { IconLoader2 } from '@tabler/icons-react';
import s from './kit.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'soft' | 'ask' | 'danger';

type Base = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  /** primary = Cargo Ink (mỗi thanh một nút) · secondary = viền · ghost · soft (nền xám, "Lọc ▾") · ask = xanh Ask HANA · danger = không hoàn tác */
  variant?: ButtonVariant;
  size?: 'md' | 'sm';
  icon?: ReactNode;
  busy?: boolean;
};
/** Nút icon bắt buộc có aria-label (CLAUDE.md). */
export type ButtonProps = (Base & { children: ReactNode }) | (Base & { children?: undefined; 'aria-label': string; icon: ReactNode });

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'secondary', size = 'md', icon, busy, children, className, type = 'button', disabled, title, ...rest },
  ref,
) {
  const only = children === undefined;
  const cls = [s.btn, s[variant], size === 'sm' && s.sm, only && s.iconOnly, className].filter(Boolean).join(' ');
  return (
    <button
      ref={ref}
      type={type}
      className={cls}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      title={title ?? (only ? rest['aria-label'] : undefined)}
      {...rest}
    >
      {busy ? <IconLoader2 size={16} className={s.spin} aria-hidden="true" /> : icon}
      {children}
    </button>
  );
});
